import { fetchAuthSession, JWT } from 'aws-amplify/auth';

const getTokens = async (): Promise<
  | {
      accessToken: JWT | undefined;
      idToken: JWT | undefined;
    }
  | undefined
> => {
  try {
    const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
    return { accessToken, idToken };
  } catch (err) {
    console.error('getTokens error', err);
  }
};

export { getTokens };
